import React, { useEffect, useRef } from 'react';

const WistiaVideo = ({ mediaId = "pm1w36bgos", aspect = "1.4983050847457626", style = {} }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    // Ensure Wistia scripts are loaded before creating the player
    const checkWistia = () => {
      if (window.Wistia && playerRef.current) {
        // Force re-render of the Wistia player if needed
        const existingPlayer = playerRef.current.querySelector('wistia-player');
        if (existingPlayer) {
          existingPlayer.remove();
        }
        
        // Create new player element
        const newPlayer = document.createElement('wistia-player');
        newPlayer.setAttribute('media-id', mediaId);
        newPlayer.setAttribute('aspect', aspect);
        playerRef.current.appendChild(newPlayer);
      } else {
        // Retry after a short delay if Wistia isn't ready
        setTimeout(checkWistia, 100);
      }
    };

    checkWistia();
  }, [mediaId, aspect]);

  return (
    <div 
      ref={playerRef}
      style={{
        width: '100%',
        height: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
        ...style
      }}
    >
      <wistia-player 
        media-id={mediaId} 
        aspect={aspect}
      />
    </div>
  );
};

export default WistiaVideo;